/*
  ff-analytics.js — one helper for custom GA4 events.

  The Shopify "Google & YouTube" channel pixel runs in Shopify's OPEN runtime
  context and injects gtag.js into the page for this store's GA4 property.
  We do not load gtag ourselves: doing so would create a second tag instance
  with its own session logic. Instead every custom event is handed to the
  channel's gtag, so it shares the client id, session and consent state that
  the standard ecommerce events (view_item, add_to_cart, purchase) already use.

  Usage:  window.ffTrack('quiz_start', { quiz_id: 'abc' });

  Events are buffered until the channel's gtag has configured the GA4 tag, so
  calls that happen before the pixel finishes loading are not lost. If the
  pixel never loads (consent declined, blocker) the buffer is dropped after
  20s, which is the correct outcome.

  Add ?ff_debug=1 to any URL to (a) log every call to the console and
  (b) flag the events with debug_mode so they show in GA4 DebugView. The
  flag sticks for the browser session.

  Add ?ff_silent=1 to log every call to the console WITHOUT sending it to
  GA4 at all. Use it when walking a preview theme so test sessions never
  reach the property. Also sticks for the browser session; ?ff_silent=0
  clears it.
*/
(function () {
  var GA4_ID = 'G-EWKW45Q3G6';
  var BUFFER_TIMEOUT_MS = 20000;
  var POLL_MS = 250;

  var debug = false;
  var silent = false;
  try {
    if (/[?&]ff_debug=1/.test(window.location.search)) {
      window.sessionStorage.setItem('ff_debug', '1');
    }
    if (/[?&]ff_silent=1/.test(window.location.search)) {
      window.sessionStorage.setItem('ff_silent', '1');
    } else if (/[?&]ff_silent=0/.test(window.location.search)) {
      window.sessionStorage.removeItem('ff_silent');
    }
    debug = window.sessionStorage.getItem('ff_debug') === '1';
    silent = window.sessionStorage.getItem('ff_silent') === '1';
  } catch (e) {
    /* storage unavailable */
  }

  var queue = [];
  var ready = false;
  var startedAt = Date.now();

  function ga4Ready() {
    return (
      typeof window.gtag === 'function' &&
      window.google_tag_manager &&
      window.google_tag_manager[GA4_ID]
    );
  }

  function send(name, params) {
    var payload = { send_to: GA4_ID };
    for (var key in params) {
      if (Object.prototype.hasOwnProperty.call(params, key) && params[key] !== undefined && params[key] !== null) {
        payload[key] = params[key];
      }
    }
    if (silent) {
      // eslint-disable-next-line no-console
      console.log('[ff-analytics] (silent, not sent)', name, payload);
      return;
    }
    if (debug) {
      payload.debug_mode = true;
      // eslint-disable-next-line no-console
      console.log('[ff-analytics]', name, payload);
    }
    try {
      window.gtag('event', name, payload);
    } catch (e) {
      /* never break the page for analytics */
    }
  }

  function flush() {
    ready = true;
    var pending = queue;
    queue = [];
    pending.forEach(function (item) {
      send(item[0], item[1]);
    });
  }

  function poll() {
    if (ga4Ready()) {
      flush();
      return;
    }
    if (Date.now() - startedAt > BUFFER_TIMEOUT_MS) {
      queue = [];
      if (debug) {
        // eslint-disable-next-line no-console
        console.warn('[ff-analytics] GA4 tag never loaded; dropping buffered events');
      }
      return;
    }
    window.setTimeout(poll, POLL_MS);
  }

  window.ffTrack = function (name, params) {
    if (!name) return;
    if (ready) {
      send(name, params || {});
    } else {
      queue.push([name, params || {}]);
    }
  };

  // Truncate a string to GA4's 100-character parameter limit.
  window.ffTrack.clip = function (value, max) {
    if (value === undefined || value === null) return undefined;
    var str = String(value).replace(/\s+/g, ' ').trim();
    return str.length > (max || 100) ? str.slice(0, (max || 100) - 1) + '…' : str;
  };

  poll();
})();
